<div class="container-fluid">
  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>
  <ng-template #loaded>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">
        <i class="fas fa-chart-line mr-2"></i>{{ dashboardI18n?.titleI18n || 'Bảng điều khiển' }}
      </h1>
    </div>

    <p class="lead">
      Giám sát và phân tích các chỉ số quan trọng của thư viện theo thời gian thực. Sử dụng bảng điều khiển để theo dõi sách, thành viên, danh mục, sách đã phát hành và các thống kê quan trọng khác một cách dễ dàng.
    </p>

    <div class="row">
      <!-- Số sách -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-primary shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
                  <i class="fas fa-book mr-2"></i>{{ dashboardI18n?.booksNumberI18n || 'Số sách' }}
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ dashboardAnalytics?.bookNumber }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-book fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Số thành viên -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                  <i class="fas fa-users mr-2"></i>{{ dashboardI18n?.membersNumberI18n || 'Số thành viên' }}
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ dashboardAnalytics?.memberNumber }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-users fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Số danh mục -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-info shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-info text-uppercase mb-1">
                  <i class="fas fa-th-list mr-2"></i>{{ dashboardI18n?.categoriesNumberI18n || 'Số danh mục' }}
                </div>
                <div class="row no-gutters align-items-center">
                  <div class="col-auto">
                    <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">
                      {{ dashboardAnalytics?.categoryNumber }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-list-alt fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sách đã phát hành -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-warning shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
                  <i class="fas fa-book-open mr-2"></i>{{ dashboardI18n?.issueBookNumberI18n || 'Sách đã phát hành' }}
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ dashboardAnalytics?.issueBookNumber }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-book-open fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Biểu đồ và thống kê -->
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4 class="mb-3">{{ dashboardI18n?.itemsByCategoryI18n || 'Số lượng sách theo danh mục' }}</h4>
            <ngx-charts-bar-vertical
              [view]="viewCategory"
              [scheme]="'cool'"
              [results]="itemsByCategoryData"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legend]="showLegend"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="xAxisLabelCategory"
              [yAxisLabel]="yAxisLabelCategory"
              (select)="onSelect($event)"
              style="width: 100%; height: 300px;">
            </ngx-charts-bar-vertical>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4 class="mb-3">{{ dashboardI18n?.itemsByMediaTypeI18n || 'Phân phối sách theo loại' }}</h4>
            <ngx-charts-pie-chart
              [view]="viewMediaType"
              [scheme]="'cool'"
              [results]="itemsByMediaTypeData"
              [legend]="showLegend"
              [labels]="showLabels"
              [doughnut]="isDoughnut"
              [gradient]="gradient"
              (select)="onSelect($event)"
              style="width: 100%; height: 400px;">
            </ngx-charts-pie-chart>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4><i class="fas fa-bar-chart"></i> Số thành viên theo thành phố</h4>
            <ngx-charts-bar-vertical
              [view]="viewCategory"
              [scheme]="'cool'"
              [results]="membersByCityData"
              [gradient]="gradient"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="showLegend"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxisLabel]="'Số thành viên'"
              [yAxisLabel]="'Thành phố'"
              style="width: 100%; height: 300px;">
            </ngx-charts-bar-vertical>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4><i class="fas fa-pie-chart"></i> Phân bố thành viên theo giới tính</h4>
            <ngx-charts-pie-chart
              [view]="viewSize"
              [scheme]="'cool'"
              [results]="genderDistributionData"
              [legend]="showLegend"
              [labels]="showLabels"
              [doughnut]="isDoughnut"
              [gradient]="gradient"
              style="width: 100%; height: 400px;">
            </ngx-charts-pie-chart>
          </div>
        </div>
      </div>

      <!-- Các biểu đồ khác có thể dịch tương tự -->
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4>Số lượng sách theo loại phương tiện</h4>
            <ngx-charts-bar-vertical
              [view]="viewCategory"
              [scheme]="'cool'"
              [results]="mediaItemsByTypeData"
              [gradient]="gradient"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="showLegend"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxisLabel]="'Loại phương tiện'"
              [yAxisLabel]="'Số lượng'"
              style="width: 100%; height: 300px;">
            </ngx-charts-bar-vertical>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h4>Phân phối sách theo thể loại</h4>
            <ngx-charts-pie-chart
              [view]="view"
              [scheme]="'cool'"
              [results]="mediaByGenreData"
              [legend]="showLegend"
              [labels]="showLabels"
              [doughnut]="isDoughnut"
              [gradient]="gradient"
              style="width: 100%; height: 400px;">
            </ngx-charts-pie-chart>
          </div>
        </div>
      </div>
    </div>

    <!-- Thông tin thư viện -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800 ml-3">
        <i class="fas fa-chart-pie mr-2"></i> Thông tin thư viện
      </h1>
    </div>

    <p class="lead ml-3">
      Phần <strong>Thông tin thư viện</strong> hiển thị các dữ liệu quan trọng, bao gồm tác giả hàng đầu, nhà xuất bản nổi bật, sách mượn nhiều nhất, thể loại phổ biến và nhiều thông tin khác. Giúp bạn nhanh chóng nắm bắt xu hướng và tối ưu hóa hoạt động thư viện.
    </p>

    <!-- Tab thống kê -->
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#TopAuthors">
                  <i class="fas fa-user mr-2"></i> Tác giả hàng đầu
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#TopPublications">
                  <i class="fas fa-newspaper mr-2"></i> Nhà xuất bản hàng đầu
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#MostPopularGenres">
                  <i class="fas fa-tags mr-2"></i> Thể loại phổ biến
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#TopCirculatingBooks">
                  <i class="fas fa-sync-alt mr-2"></i> Sách mượn nhiều nhất
                </a>
              </li>
            </ul>

            <div class="tab-content mt-3">
              <!-- Tác giả hàng đầu -->
              <div id="TopAuthors" class="container tab-pane active">
                <h2>Tác giả hàng đầu</h2>
                <table class="table table-striped">
                  <thead><tr><th>Tên tác giả</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let author of topAuthors"><td>{{author[0]}}</td></tr>
                  </tbody>
                </table>
              </div>

              <!-- Nhà xuất bản hàng đầu -->
              <div id="TopPublications" class="container tab-pane fade">
                <h4>Nhà xuất bản hàng đầu</h4>
                <table class="table table-striped">
                  <thead><tr><th>Tên nhà xuất bản</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let publication of topPublications"><td>{{publication[0]}}</td></tr>
                  </tbody>
                </table>
              </div>

              <!-- Thể loại phổ biến -->
              <div id="MostPopularGenres" class="container tab-pane fade">
                <h4>Thể loại phổ biến</h4>
                <table class="table table-striped">
                  <thead><tr><th>Tên thể loại</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let genre of mostPopularGenres"><td>{{genre[0]}}</td></tr>
                  </tbody>
                </table>
              </div>

              <!-- Sách mượn nhiều nhất -->
              <div id="TopCirculatingBooks" class="container tab-pane fade">
                <h4>Sách mượn nhiều nhất</h4>
                <table class="table table-striped">
                  <thead><tr><th>Tên sách</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let book of topCirculatingBooks"><td>{{book[0]}}</td></tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </ng-template>
</div>